export const name = 'pagesService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-pages' as const
